import { render, staticRenderFns } from "./MisFormulasPage.vue?vue&type=template&id=9b16ef46"
import script from "./MisFormulasPage.js?vue&type=script&lang=js&external"
export * from "./MisFormulasPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports